import log from 'loglevel';
import { Faq } from "@/interfaces/Faq"
import { ApiService } from "./ApiService";
import { ContactUs } from "@/interfaces/ContactUs";
import { SuccessResponse } from "@/interfaces/SuccessResponse";
import { NoTokenStrategy } from "../strategies/NoTokenStrategy";
import { ApiEndpoints } from '@/constants/ApiEndpoints';

class SupportServiceClass extends ApiService {
    private CONTACT_US_ENDPOINT = ApiEndpoints.CONTACT_US;
    private FAQ_ENDPOINT = ApiEndpoints.FAQ;
    constructor() {
        super(NoTokenStrategy);
    }
    async contactUsDetails(data: ContactUs): Promise<SuccessResponse> {
        try {
            const result = await this.post(this.CONTACT_US_ENDPOINT, data);
            return result;
        } catch (error) {
            log.error('Failed to initiate payout:', error);
            throw error;
        }
    }

    async faqDetails():Promise<Faq>{
        try{
            const response = await this.get(this.FAQ_ENDPOINT);
            const filteredData = response.data.map((faq: Faq) => ({
                question: faq.question,
                answer: faq.answer,
            }));
            return filteredData
        }catch(error){
            log.error('Failed to get faqs data:', error);
            throw error
        }
    }
}

const SupportService = new SupportServiceClass();
export { SupportService };